import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {OnboardingEventsEnum, trackEvent, TrackingTypesEnum} from '../../../../services/tracking';
import {getCompany} from '../../../../store/data/company/companySelectors';
import {saveUserAction} from '../../../../store/data/teammates/teammatesActions';
import {
  getFlatTeammates,
  getIsUserFirstGlobalAdmin,
  getUser,
} from '../../../../store/data/teammates/teammatesSelectors';
import {getFlatTeams} from '../../../../store/data/teams/teamsSelectors';
import {saveUserMetadataAction} from '../../../../store/data/userMetadata/userMetadataActions';
import {getUserMetadata} from '../../../../store/data/userMetadata/userMetadataSelectors';
import {WelcomeCarouselFormContainerProps} from '../welcomeCarouselCommon';
import {WelcomeCarouselPersonaForm} from './welcomeCarouselPersonaForm';

/*
 * Constants.
 */

// eslint-disable-next-line no-useless-escape
const aliasPattern = /[a-z0-9][a-z0-9_\.]{0,62}[a-z0-9]/;
const aliasRegex = RegExp(`^${aliasPattern.source}$`);

export interface PersonaFormOptions {
  givenName?: string;
  familyName?: string;
  alias?: string;
  phone?: string;
  department?: string;
}

/*
 * Selectors.
 */

const getTeammateAliases = createSelector([getFlatTeammates], (teammates) => teammates.map((t) => t.alias));

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  user: getUser,
  isUserFirstGlobalAdmin: getIsUserFirstGlobalAdmin,
  company: getCompany,
  userMetadata: getUserMetadata,
  teammateAliases: getTeammateAliases,
  teams: getFlatTeams,
}));

export const WelcomeCarouselPersonaFormContainer = connect(
  mapStateToProps,
  {
    saveUser: saveUserAction,
    saveUserMetadata: saveUserMetadataAction,
  },
  (stateProps, dispatchProps, ownProps: WelcomeCarouselFormContainerProps) => {
    const {user, isUserFirstGlobalAdmin, userMetadata, teammateAliases} = stateProps;
    const {saveUser, saveUserMetadata} = dispatchProps;
    const {onCompleteForm} = ownProps;

    const getAliasErrorMessage = (alias: string) => {
      if (alias.length < 1) {
        return 'Please enter a username';
      }

      if (!aliasRegex.test(alias)) {
        return 'Lowercase letters, numbers, underscores, and periods only';
      }

      if (teammateAliases.includes(alias) && alias !== user.alias) {
        return 'That username is unavailable';
      }

      return null;
    };

    const submitForm = (options: PersonaFormOptions) => {
      const {givenName, familyName, alias, phone, department} = options;

      saveUser({givenName, familyName, alias, phone});
      saveUserMetadata({department});
      trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED_IDENTITY_INFO);
      onCompleteForm();
    };

    return {
      user,
      isUserFirstGlobalAdmin,
      department: userMetadata.department,
      getAliasErrorMessage,
      submitForm,
    };
  },
)(WelcomeCarouselPersonaForm);
